<template>
  <vue-apex-charts type="area" height="450"
                   :options="optionsObj"
                   :series="seriesList"/>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    optionsObj: Object,
    seriesList: Array,
  },
  components: {
    VueApexCharts
  },
  data() {
    return {
      lineAreaChartSpline: {
        series: [],

        chartOptions: {
          dataLabels: {
            enabled: false
          },
          chart: {
            toolbar: {
              show: true
            }
          },
          stroke: {
            curve: 'smooth',
            width: 2
          },
          colors: ['#2962FF', '#4fc3f7', '#f62d51', '#ffbc34', '#212529'],
          xaxis: {
            type: 'time',
            categories: this.xaxisList,
            labels: {
              style: {
                cssClass: 'text-muted fill-color',
              }
            },
          },
          yaxis: {
            labels: {
              style: {
                cssClass: 'text-muted fill-color',
              }
            },
          },
          markers: {
            size: 3,
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },
            theme: 'dark',
          },
          legend: {
            show: true
          },
          grid: {
            show: true,
            borderColor: 'rgba(0,0,0,0.1)',

          }
        }
      },
    }
  }
}
</script>
